import * as React from "react";
import { AskAboutQuery_RichAnswer } from "../../../../graphql-types";
import TextAnswer from "../../ui-library/answers/text-answer";
import ImageAnswer from "../../ui-library/answers/image-answer";
import VideoAnswer from "../../ui-library/answers/video-answer";

interface RichAnswersProps {
  displayName: string;
  richAnswers: AskAboutQuery_RichAnswer[];
}

const RichAnswers: React.FC<RichAnswersProps> = ({
  displayName,
  richAnswers,
}) => {
  return (
    <>
      {richAnswers.map(
        (
          { type, title, content, imageUrl, youtubeId, sources, tip },
          answerIndex
        ) => {
          if (type === "text" && !!content && !!content[0]) {
            return (
              <TextAnswer
                key={title || content[0].slice(0, 16)}
                intentName={displayName}
                answerIndex={answerIndex}
                title={title || undefined}
                content={content}
                tip={tip || undefined}
                sources={sources}
              />
            );
          }

          if (type === "image" && !!title && !!imageUrl) {
            return (
              <ImageAnswer
                key={title}
                intentName={displayName}
                answerIndex={answerIndex}
                imageUrl={imageUrl}
                title={title}
                content={content || undefined}
                sources={sources}
              />
            );
          }

          if (type === "video" && !!title && !!youtubeId) {
            return (
              <VideoAnswer
                key={title}
                intentName={displayName}
                answerIndex={answerIndex}
                youtubeId={youtubeId}
                title={title}
                content={content || undefined}
                sources={sources}
              />
            );
          }
          return null;
        }
      )}
    </>
  );
};

export default RichAnswers;
